var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckMark({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0497 34.4015L15.0309 38.3839L18.0477 34.6335L18.0359 34.6177L18.2765 34.3156L36.0956 11.9469L33.3478 8.27621L15.6931 30.4427L15.2897 30.9491L14.9017 30.4308L8.06146 21.2933L5.64447 25.845L12.0497 34.4015Z",
    stroke: "white"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEyLjA0OTcgMzQuNDAxNUwxNS4wMzA5IDM4LjM4MzlMMTguMDQ3NyAzNC42MzM1TDE4LjAzNTkgMzQuNjE3N0wxOC4yNzY1IDM0LjMxNTZMMzYuMDk1NiAxMS45NDY5TDMzLjM0NzggOC4yNzYyMUwxNS42OTMxIDMwLjQ0MjdMMTUuMjg5NyAzMC45NDkxTDE0LjkwMTcgMzAuNDMwOEw4LjA2MTQ2IDIxLjI5MzNMNS42NDQ0NyAyNS44NDVMMTIuMDQ5NyAzNC40MDE1WiIgIHN0cm9rZT0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCheckMark as ReactComponent };